<template>
  <div class="customer">
    <van-sticky>
      <div class="header">
        <van-icon class="vanIcon" name="arrow-left" color="#fff" @click="returnIndex" />
        <span class="addInfo">输入编号</span>
      </div>
    </van-sticky>

    <div class="sticky" v-if="flag">
      <div class="appointInfo">请输入编号:</div>
      <input class="border" type="text" placeholder="编号5位数字,1患者,2陪同" v-model="form.customerName" />
    </div>

    <div class="sticky" v-if="isFlag">
      <div class="appointInfo">编号10310</div>
      <van-cell-group class="arrowLine">
        <van-field v-model="formList.a" label="陪同:" />
        <van-field v-model="formList.b" label="手机号:" />
        <van-field v-model="formList.c" label="本人:" />
      </van-cell-group>
    </div>
    <div class="selectSure" @click="sure">确定</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      formList: {
        a: '000',
        b: '000',
        c: '000'
      },
      flag: true,
      isFlag: false,
    }
  },
  created() { },
  methods: {
    returnIndex() {
      this.$router.push("/customer")
    },
    sure() {
      if (this.flag = true) {
        this.flag = false
        this.isFlag = true
      } else if (this.flag = false) {
        this.isFlag = false
        this.flag = true
      }
    }
  },
}

</script>
<style scoped>
.customer >>> .van-cell {
  border-bottom: 1px solid #4f89ea;
  padding: 10px 0;
  box-sizing: border-box;
}
.customer >>> .van-field__control {
  text-align: right;
}
.appointInfo {
  font-size: 0.937rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: bold;
  color: #000;
}
input {
  border: none;
  width: 95%;
  border-bottom: 1px solid #4f89ea;
  padding: 0.7rem;
  box-sizing: border-box;
  font-size: 0.937rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #bababa;
  margin-top: 0.75rem;
}
.border {
  border-radius: 10px;
  border: 1px solid #4f89ea;
}
.sticky {
  width: 90%;
  margin: 1rem auto;
  background: #fff;
  border-radius: 8px;
  padding: 0.75rem;
  box-sizing: border-box;
}
.vanIcon {
  position: absolute;
  left: 1.3rem;
}
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.selectSure {
  width: 80%;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 2.875rem;
  background: linear-gradient(122deg, #17bcc5 0%, #0164a8 100%);
  border-radius: 5rem;
  text-align: center;
  line-height: 3rem;
  font-size: 0.9375rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin: 1rem 0 1rem 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/customerReception/addCustomer.vue